import { render, staticRenderFns } from "./AttentionTree.vue?vue&type=template&id=2b76f2fb&scoped=true&"
import script from "./AttentionTree.vue?vue&type=script&lang=js&"
export * from "./AttentionTree.vue?vue&type=script&lang=js&"
import style0 from "./AttentionTree.vue?vue&type=style&index=0&id=2b76f2fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b76f2fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2b76f2fb', component.options)
    } else {
      api.reload('2b76f2fb', component.options)
    }
    module.hot.accept("./AttentionTree.vue?vue&type=template&id=2b76f2fb&scoped=true&", function () {
      api.rerender('2b76f2fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/new_attention/AttentionTree.vue"
export default component.exports